module.exports = __webpack_public_path__ + "img/GM.67bfd1fb.png";